import { render, staticRenderFns } from "./ScenarioIntro.vue?vue&type=template&id=535e872a&scoped=true&"
import script from "./ScenarioIntro.vue?vue&type=script&lang=js&"
export * from "./ScenarioIntro.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioIntro.vue?vue&type=style&index=0&id=535e872a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e872a",
  null
  
)

export default component.exports